"use client";

import { cn } from "@kyan/ui";
import { createPortal } from "react-dom";

import { Logo } from "#/components/Logo/Logo";
import { useTopBannerFeatureFlag } from "#/hooks/featureFlags/useTopBannerFeatureFlag";
import { useEoa } from "#/store/wallet/eoa/eoa";

import { Deposit } from "./components/Deposit/Deposit";
import { HelpButton } from "./components/HelpButton/HelpButton";
// import { MoreMenu } from "./components/MoreMenu/MoreMenu";
import { Navbar } from "./components/Navbar";
import { OneClickTradingModal } from "./components/OneClickTradingModal/OneClickTradingModal";
import { PortfolioMenu } from "./components/PortfolioMenu";
import { PortfolioRiskDropdown } from "./components/PortfolioRiskDropdown/PortfolioRiskDropdown";
import { ThemeSwitcher } from "./components/ThemeSwitcher";
import { WalletDropdown } from "./components/WalletDropdown";
import { WelcomeModal } from "./components/WelcomeModal/WelcomeModal";

export const Header: React.FC = () => {
  const { showTopBanner } = useTopBannerFeatureFlag();
  const { isEoaConnected } = useEoa();

  const headerContent = (
    <header
      className={cn(
        "bg-background border-divider fixed inset-0 bottom-auto flex h-20 min-h-20 border-b shadow-[0px_2px_14px_0px_rgba(201,201,201,0.50)] dark:shadow-none",
        {
          "top-18": showTopBanner,
        },
      )}
    >
      <div className="flex w-full items-center justify-between pl-5">
        <div className="flex h-full items-center gap-2 xl:gap-10">
          <Logo />
          <div className="flex h-full items-center">
            <PortfolioMenu />
            <Navbar />
            {/* <MoreMenu /> */}
          </div>
        </div>

        <div className="flex h-full">
          {isEoaConnected ? (
            <>
              <PortfolioRiskDropdown />
              <Deposit />
              <HelpButton />
              <OneClickTradingModal />
              <WelcomeModal />
            </>
          ) : (
            <>
              <ThemeSwitcher />
              <HelpButton />
            </>
          )}
          <WalletDropdown />
        </div>
      </div>
    </header>
  );

  if (typeof document !== "undefined") {
    return createPortal(headerContent, document.body);
  }

  return headerContent;
};
